
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_gply9_93",
  "item": "awsui_item_dwuol_gply9_98",
  "checkbox": "awsui_checkbox_dwuol_gply9_102",
  "filter": "awsui_filter_dwuol_gply9_111",
  "trigger": "awsui_trigger_dwuol_gply9_116",
  "layout-strut": "awsui_layout-strut_dwuol_gply9_122",
  "list-bottom": "awsui_list-bottom_dwuol_gply9_128",
  "selected-icon": "awsui_selected-icon_dwuol_gply9_132",
  "show-label-tag": "awsui_show-label-tag_dwuol_gply9_136",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_gply9_140",
  "inline-token-list": "awsui_inline-token-list_dwuol_gply9_147",
  "inline-token": "awsui_inline-token_dwuol_gply9_140",
  "visual-refresh": "awsui_visual-refresh_dwuol_gply9_168",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_gply9_172",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_gply9_178",
  "inline-token-trigger--disabled": "awsui_inline-token-trigger--disabled_dwuol_gply9_182"
};
  